export const actions = {
  clearSnackData({ commit }) {
    commit('clearSnackData');
  },

  setSnackData({ commit }, snackInfo) {
    commit('setSnackData', { snackInfo });
  },
};
